import React, {ReactNode} from 'react';
import {Grid, GridSize, Paper} from "@mui/material";

interface IProps {
    leftPanelSize?: GridSize
    leftPanel: ReactNode
    rightPanelSize?: GridSize
    rightPanel: ReactNode
}

interface IState {
}

export default class TwoSidedPage extends React.Component<IProps, IState> {

    render() {

        const {leftPanelSize, leftPanel, rightPanelSize, rightPanel} = this.props;
        return <Grid container style={{height: "100%"}} spacing={0.5}>
            <Grid item xs={leftPanelSize ?? 1}>
                <Paper variant="elevation" style={{height: "100%", overflow: "hidden"}}>
                    {leftPanel}
                </Paper>
            </Grid>
            <Grid item xs={rightPanelSize ?? 11}>
                <Paper variant="elevation" style={{height: "100%", overflow: "hidden"}}>
                    {rightPanel}
                </Paper>
            </Grid>
        </Grid>
    }
}